import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { CustomSelectComponent } from '@/components/custom-select/custom-select.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

const STATUSES = [
  { id: 'free', name: 'Libre' },
  { id: 'occupied', name: 'Ocupada' },
  { id: 'reserved', name: 'Reservada' },
  { id: 'dirty', name: 'Por limpiar' },
];

@Component({
  selector: 'app-table-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    CustomSelectComponent,
    LoadingComponent,
  ],
  templateUrl: './table-form.component.html',
  styleUrl: './table-form.component.scss',
})
export class TableFormComponent {
  @Input() id: number | string = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  public statuses = STATUSES;

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.id != 0) {
      this.getById(this.id);
    }
  }

  acceptFormFunction() {
    this.saveEntity();
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      capacity: new FormControl(null, [Validators.min(1)]),
      status: new FormControl('free', [Validators.required]),
      position_x: new FormControl(null),
      position_y: new FormControl(null),
    });
  }

  getById(id: number | string) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.tables, id).subscribe({
      next: (data: any) => {
        this.saveForm.patchValue(data);
        this.loading.set(false);
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al obtener la mesa');
        this.loading.set(false);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.tables, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success(this.id ? 'Mesa actualizada' : 'Mesa creada');
          this.acceptFunction.emit(response);
          this.closeFormFunction();
        },
        error: (error: any) => {
          this.saving.set(false);
          Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar la mesa');
        },
        complete: () => {
          this.saving.set(false);
        }
      });
    } else {
      Utils.notification.alert('Debe completar todos los campos obligatorios');
    }
  }

}
